<template>
  <div class="dashboard-page">
  </div>
</template>

<script>
export default {
  name: 'DashboardView'
}
</script>

<style scoped>
.dashboard-page {
  min-height: 60vh;
}
</style>
